export const HTTP_OPTIONS_KEYS = [
  'headers',
  'observe',
  'params',
  'reportProgress',
  'responseType',
  'withCredentials',
];

export const HTTP_OPTION_PREFIX = '~';
